import { Card, CardContent, Tooltip } from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import { useStyles } from '../../styles';
import {
  getScoreBackgroundClassByScore,
  getTextColorByScore,
  constructLink,
  getWholePercentage,
} from '../../utils';

interface QESummaryCardProps {
  currentMonthWeight: number;
  maximumWeightLimit: number;
  applicationName: string;
}

export function QEScoreStatusCard({
  currentMonthWeight,
  maximumWeightLimit,
  applicationName,
}: QESummaryCardProps) {
  const classes = useStyles();

  return (
    <Card className={classes.qeScoreStatusCard}>
      <CardContent
        className={`flex flex-col gap-2 ${classes.qeScoreStatusContent}`}
      >
        <span
          className={`flex items-center gap-1 text-xl font-semibold ${classes.qeScoreStatusTitle}`}
        >
          QE Score
          <Tooltip title="QE Score Details">
            <a
              href={constructLink(applicationName)}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                color: 'inherit',
              }}
            >
              <OpenInNewOutlinedIcon style={{ fontSize: 20 }} />
            </a>
          </Tooltip>
        </span>
        <div
          className={`px-4 sm:px-6 py-2 sm:py-3 rounded text-xs sm:text-sm font-semibold w-fit ${getScoreBackgroundClassByScore(
            currentMonthWeight,
            classes,
          )}`}
        >
          <span style={{ color: getTextColorByScore(currentMonthWeight) }}>
            {currentMonthWeight} / {maximumWeightLimit}{' '}
            {getWholePercentage(currentMonthWeight, maximumWeightLimit)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
